import React, { useState, useContext } from "react";
import axios from "axios";
import { useDropzone } from "react-dropzone";
import { closeIcon } from "../Icons";

import inputStyle from "../../styles/input.module.scss";
import { MaterialContext } from "../../context/MaterialContext";

function Dropzone({ vendor, slug, setUploadedImages, onUploadSuccess }) {
  const { ROOT_SERVER } = useContext(MaterialContext);
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      "image/*": [],
    },
    onDrop: (acceptedFiles) => {
      const flatten = acceptedFiles
        .map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          }),
        )
        .map((item) => item);
      setFiles((files) => [...files, ...flatten]);
    },
  });

  const handleDeleteFromUpload = (item) => {
    const removeItemFromArray = files.filter((file) => file !== item);
    setFiles(removeItemFromArray);
  };

  const handleSubmit = () => {
    if (!files.length || uploading) {
      return;
    }
    setUploading(true);
    if (files.length) {
      const formData = new FormData();
      formData.append("vendor", vendor);
      formData.append("slug", slug);
      const uploadedNames = files.map((file) => file.name);
      for (let i = 0; i < files.length; i++) {
        formData.append("file", files[i]);
      }
      axios
        .post(`${ROOT_SERVER}upload/images`, formData)
        .then((res) => {
          if (res.status === 200) {
            const storedNames = Array.isArray(res.data?.images)
              ? res.data.images
              : uploadedNames.map((name) => {
                  const base = String(name)
                    .replace(/\.[^/.]+$/, "")
                    .trim()
                    .toLowerCase()
                    .replace(/,/g, "")
                    .split(/\s+/)
                    .join("-");
                  return `${base}.webp`;
                });
            if (onUploadSuccess) {
              onUploadSuccess(storedNames);
            }
            setUploadedImages(true);
            setFiles([]);
          }
        })
        .catch((errors) =>
          console.log("there is an error in dropzone", errors),
        )
        .finally(() => {
          setUploading(false);
        });
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
      <div className={inputStyle.dropDeck}>
        {files.length
          ? files.map((preview, i) => (
              <div key={preview.name + i} className={inputStyle.dragDropItem}>
                <div
                  className={inputStyle.deleteDragDropItem}
                  onClick={() => handleDeleteFromUpload(preview)}
                >
                  <div className={inputStyle.deleteIcon}>{closeIcon}</div>
                </div>
                <img
                  src={preview.preview}
                  alt={preview.name}
                  width="100"
                  height="100"
                />
              </div>
            ))
          : null}
        <div
          className={
            files.length !== 0
              ? inputStyle.dropZone
              : inputStyle.dropZoneExpanded
          }
          {...getRootProps()}
        >
          <input {...getInputProps()} />
          {isDragActive ? (
            <p>Drop images here</p>
          ) : (
            <p>Drop images or click to browse</p>
          )}
        </div>
      </div>
      {files.length ? (
        <div className={inputStyle.dropZoneUpload} onClick={handleSubmit}>
          {uploading ? "uploading" : "submit"}
        </div>
      ) : null}
    </div>
  );
}
export default Dropzone;
